const initialState = {
  suppliers: null,
  supplierSegments: null,
};

export default initialState;
